// extracted by mini-css-extract-plugin
export default {"button":"YDvkm8"};